import { useAppConfig } from 'api/appConfig';
import LoadingPage from 'app/pages/Loading/LoadingPage';
import UnauthorizedPage from 'app/pages/Unauthorized/UnauthorizedPage';
import PageLayout from 'components/PageLayout/PageLayout';
import { ROUTES } from 'constants/routes';
import { useAuthContext } from 'contexts/AuthContext';
import { useModeTheme } from 'contexts/ModeThemeContext';
import { useInitIdpConfigContext } from 'hooks/initIdpConfigContext';
import { useAutoNavigateOnAppInit } from 'hooks/useAutoNavigateOnAppInit';
import React, { PropsWithChildren, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useNav } from 'utils/navigation';
import { toRelativeRoute } from 'utils/routeUtils';

const AppInit: React.FC<PropsWithChildren> = ({ children = null }) => {
	const { authRes } = useAuthContext();
	const {
		data: appConfig,
		isError: appConfigError,
		isLoading: appConfigLoading
	} = useAppConfig();
	const { themeLoaded } = useModeTheme();
	const idpContextInit = useInitIdpConfigContext();

	const nav = useNav();
	useAutoNavigateOnAppInit(idpContextInit && !!appConfig);

	const initError = (authRes.done && !authRes.verified) || appConfigError;
	const loader =
		initError ||
		!authRes.verified ||
		!themeLoaded ||
		!idpContextInit ||
		appConfigLoading;

	useEffect(() => {
		if (initError) {
			nav(ROUTES.unauthorized);
		}
	}, [initError, nav]);

	return loader ? (
		<Routes>
			<Route
				path={toRelativeRoute(ROUTES.unauthorized)}
				element={
					<PageLayout>
						<UnauthorizedPage />
					</PageLayout>
				}
			/>
			{themeLoaded && initError ? (
				<Route
					path="*"
					element={
						<PageLayout>
							<UnauthorizedPage />
						</PageLayout>
					}
				/>
			) : (
				<Route
					path="*"
					element={
						<PageLayout>
							<LoadingPage />
						</PageLayout>
					}
				/>
			)}
		</Routes>
	) : (
		children
	);
};

export default AppInit;
